import AxiosAiWorkforce from '@/services/api/ai_workforce/axios_ai_workforce'

export default {
  sendMessage: (data) => {
    const formData = new FormData()

    formData.append('chatInput', data.chatInput)
    formData.append('sessionId', data.sessionId)
    formData.append('rootNodeId', data.rootNodeId)

    if (data.file) {
      formData.append('file', data.file)
    }

    return AxiosAiWorkforce.post('send-message', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  getChatHistory: (params) => {
    return AxiosAiWorkforce.get('get-messages', { params })
  },

  getUserSessions: (params) => {
    return AxiosAiWorkforce.get('get-user-sessions', { params })
  },

  createUserSession: () => {
    return AxiosAiWorkforce.post('create-session')
  },

  removeUserSession: (session) => {
    return AxiosAiWorkforce.delete('inactivate-session', { params: {
      sessionId: session.session_id
    }})
  },

  renameUserSession: (session) => {
    return AxiosAiWorkforce.put('rename-session', {
      sessionId: session.session_id,
      title: session.title
    })
  },

  generateUserSessionTitle: (session) => {
    return AxiosAiWorkforce.put('session-title', {
      sessionId: session.session_id
    })
  }
}
